'use client';

import { Icon } from '@/components/ui';
import { cn } from '@/libs';

type StepBulletProps = {
  step: number;
  currentStep: number;
  isLastStep: boolean;
};

export const StepBullet = ({ step, currentStep, isLastStep }: StepBulletProps) => {
  const isActive = step === currentStep;
  const isCompleted = step < currentStep;

  return (
    <div
      className={cn(
        'w-8 h-8 rounded-full flex items-center justify-center border transition-colors',
        isActive || isCompleted
          ? 'bg-primary text-primary-foreground border-transparent'
          : 'bg-background-variant text-foreground/40 border-primary/20',
      )}
    >
      {isCompleted || (isActive && isLastStep) ? (
        <Icon.Check width={12} height={12} className="text-primary-foreground" />
      ) : (
        <span className="text-xs md:text-base font-bold">{step}</span>
      )}
    </div>
  );
};
